import * as React from 'react';
import { Fragment } from 'react';
import {
  AutocompleteInput,
  BooleanField,
  DatagridConfigurable,
  Datagrid,
  DateField,
  DateInput,
  ExportButton,
  FilterButton,
  NullableBooleanInput,
  ReferenceInput,
  SearchInput,
  SelectColumnsButton,
  TextField,
  TextInput,
  TopToolbar,
  ShowButton,
  EditButton,
  ReferenceField,
  DeleteButton,
  FunctionField,
  WrapperField,
  CreateButton
} from 'react-admin';
import { useMediaQuery, Divider, Theme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ComponentList from '../../components/PageComponents/ComponentList';
import { AccountFilter } from '../../components/PageComponents/ComponentList';
import { StatusLabel } from '../../components/Label/status';
import MobileGrid from './MobileGrid';
import { Project } from '../../models/project';
import { BulkActionButtons, ListActions, ListButtons } from '../../components/PageComponents/ComponentList';
import { datagridSx } from "../../components/PageComponents/datagridSx";


// An entity type as read: "cryptoPayment" -> "Crypto payment".
export const projectTypeText = (type?: string) => {
  const words = String(type || '').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const ProjectList = () => (
  <>
    <Helmet>
      <title>Coinhouse Solutions - Entities</title>
    </Helmet>
    <ComponentList title="Entities" subtitle="Every entity set up under an account, with its type and status."  /* filters={orderFilters}  */ actions={<ListActions ressource="projects" filters={orderFilters} />}>
      <TabbedDatagrid />
    </ComponentList>
  </>
);

const orderFilters = [
  <AccountFilter />,
/*   <DateInput source="dateCreated" helperText={false}/>,
  <TextInput source="Id" helperText={false}/>, */
/*   <NullableBooleanInput source="status" helperText={false}/>,
 */];

const TabbedDatagrid = () => {
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            bulkActionButtons={<BulkActionButtons ressource="projects" />}
            rowClick="show"
            omit={[]}
            sx={datagridSx}
          >
            <TextField sortable={false} source="name" />
            <FunctionField sortable={false} source="typeProject" label="Type" render={(record) => projectTypeText(record.typeProject)} />
            <ReferenceField source="accountId" reference="accounts" label="Account" sortable={false}/>
            <DateField sortable={false} source="dateCreated" label="Created" locales="fr-FR" showTime />
            <WrapperField label="Status" sortable={false}>
              <StatusLabel statusField="status" />
            </WrapperField>
            <ListButtons ressource="projects" />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default ProjectList;